import { useMutation } from '@tanstack/react-query';
import fetchJSON from "hooks/restApiClient";
import { TENANT_ID, PRODUCT_ID } from 'constants/constants';
import urlMapping from 'constants/urlMapping';
import { tokenUtils } from 'utils';

const getLoginPayload = (response) => response?.data ?? response?.user ?? response

const login = ({ mobile, password, isdCode }) => {
    const options = {
        method: 'POST',
        headers: {
            platform: 'web',
            'product-id': '1000',
            'tenant-id': TENANT_ID,
        },
        body: {
            admission_number: mobile,
            isd_code: isdCode,
            phone: mobile,
            password,
            product_id: PRODUCT_ID,
            tenant_id: TENANT_ID,
        },
    };

    return fetchJSON(`${urlMapping.login}`, options)
    .then((response) => {
        const payload = getLoginPayload(response)
        const token = payload?.accessToken ?? response?.accessToken
        const userId = payload?.crnId ?? response?.crnId
        const { firstName, lastName } = tokenUtils.extractProfileFields(payload)

        tokenUtils.setToken(token)
        tokenUtils.setUserId(userId)

        if (firstName || lastName) {
            tokenUtils.setUserProfile({ firstName, lastName })
        } else {
            tokenUtils.syncUserProfileFromToken(token)
        }
    })};

export const useAuthentication = () => {
    return useMutation({
        mutationFn: login,
    });
};
